export const presentationLabel = (variant) => {
  if (!variant) return '—'
  if (variant.source === 'custom') {
    const n = variant.custom_seed_count || variant.seed_count || 1
    return n > 1 ? `x${n} unidades` : 'Unitario'
  }
  const n = variant.seed_count || 1
  const isSeedProduct = ['auto', 'fem'].includes(
    variant.product_type || variant.product_detail?.type
  )
  return n > 1 ? `x${n} ${isSeedProduct ? 'semillas' : 'unidades'}` : 'Unitario'
}

/** Nombre base del producto (sin presentación). */
export const ingresoItemBaseName = (item) => {
  if (!item) return 'Producto'
  if (item.source === 'custom') {
    return item.custom_name || item.product_name || 'Producto'
  }
  const detail = item.product_detail
  return detail?.name || item.product_name || 'Producto'
}

/** Nombre completo para carrito y pedidos: producto + presentación. */
export const formatIngresoLineName = (item) => {
  if (!item) return 'Producto'
  const base = ingresoItemBaseName(item)
  if (item.source === 'custom') return base
  const pres = presentationLabel(item)
  if (!pres || pres === 'Unitario') return base
  return `${base} — ${pres}`
}

export const groupCatalogItems = (items) => {
  const map = new Map()

  for (const item of items || []) {
    const key =
      item.source === 'custom' || !item.product_id
        ? `custom-${item.id}`
        : `product-${item.product_id}`

    if (!map.has(key)) {
      const detail = item.product_detail || {
        name: item.product_name,
        genotype: item.product_genotype || '',
        type: item.product_type,
        description: '',
        images: item.product_image ? [item.product_image] : [],
      }
      map.set(key, {
        key,
        productId: item.product_id,
        source: item.source,
        title: detail.name || ingresoItemBaseName(item),
        detail,
        variants: [],
      })
    }
    map.get(key).variants.push(item)
  }

  return Array.from(map.values()).map((group) => ({
    ...group,
    variants: [...group.variants].sort(
      (a, b) => (a.seed_count || 0) - (b.seed_count || 0)
    ),
  }))
}

export const groupMatchesSearch = (group, query) => {
  if (!query) return true
  const q = query.toLowerCase()
  const d = group.detail || {}
  const haystack = [
    group.title,
    d.name,
    d.genotype,
    d.description,
    d.flavors,
    d.effects,
    d.type,
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase()

  if (haystack.includes(q)) return true
  return group.variants.some((v) =>
    (v.product_name || '').toLowerCase().includes(q)
  )
}

export const typeLabel = (t) =>
  ({ fem: 'Feminizada', auto: 'Autofloreciente', merch: 'Merchandising', custom: 'Exclusivo' }[t] ||
  t ||
  '')

/** Convierte ítems de tienda ingreso al formato usado por DistributorShop (producto + blisters). */
export const mapIngresoCatalogToDistributorProducts = (items) =>
  groupCatalogItems(items).map((group) => {
    const detail = group.detail || {}
    const first = group.variants[0] || {}
    const productId = group.productId ?? `custom-${first.id}`

    const blisters = group.variants.map((item) => ({
      id: item.blister_id || item.id,
      catalogItemId: item.id,
      seed_count: item.seed_count,
      final_price: item.final_price,
      list_price: item.list_price,
      offer_discount_percent: item.offer_discount_percent || 0,
      stock: item.stock ?? 0,
      prices_visible: item.final_price != null && item.final_price !== '',
      source: item.source,
      custom_seed_count: item.custom_seed_count,
    }))

    const rawType = detail.type || first.product_type || 'custom'

    return {
      id: productId,
      name: group.title || detail.name || first.product_name || 'Producto',
      image: detail.images?.[0] || first.product_image,
      image_2: detail.images?.[1],
      image_3: detail.images?.[2],
      type: rawType,
      available: true,
      genotype: detail.genotype || first.product_genotype || '',
      description: detail.description || '',
      flavors: detail.flavors || '',
      effects: detail.effects || '',
      thc: detail.thc || '',
      cbd: detail.cbd || '',
      indica: detail.indica || '',
      sativa: detail.sativa || '',
      flowering_time: detail.flowering_time || '',
      completed_cicle: detail.completed_cicle || '',
      yield_indoor: detail.yield_indoor || '',
      yield_outdoor: detail.yield_outdoor || '',
      height_indoor: detail.height_indoor || '',
      height_outdoor: detail.height_outdoor || '',
      product_size: detail.product_size || '',
      limited_edition: !!detail.limited_edition,
      highlighted: !!detail.highlighted,
      blisters,
    }
  })
